export default __webpack_public_path__ + "static/media/collection-logo-default.aa754d59.png";